module.exports = __webpack_public_path__ + "img/thumb_39.14800b44.jpg";